// Generated by Copilot
import { Icon } from "@blueprintjs/core";

import { SUBTEXT_COLOR } from "@/css/constants";
import { ComponentStatus } from "@/graphql";
import { ParticipantComponent } from "@/types/programs";
import { NonNullableArrayItem } from "@/utils/types";

import { OneOneMeetingDateTimeDisplay } from "./OneOneMeetingDateTimeDisplay";

type ChildComponent = NonNullableArrayItem<
  NonNullable<ParticipantComponent["childComponents"]>
>;

const DOT_COLORS: Partial<Record<ComponentStatus, string>> = {
  [ComponentStatus.Completed]: "#27AE60",
  [ComponentStatus.InDesign]: "#3788EE",
  [ComponentStatus.Missed]: "#C61D1D",
  [ComponentStatus.NoResponse]: "#C61D1D",
  [ComponentStatus.Ongoing]: "#3788EE",
  [ComponentStatus.Upcoming]: "#3788EE",
  [ComponentStatus.Soon]: "#3788EE",
  [ComponentStatus.DidNotFinish]: "#C61D1D",
  [ComponentStatus.DidNotPass]: "#C61D1D",
};

interface OneOneMeetingSectionItemProps {
  component: ChildComponent;
  isParticipantView: boolean;
}

export function OneOneMeetingSectionItem({
  component,
  isParticipantView,
}: OneOneMeetingSectionItemProps) {
  const componentStatus = component?.status;
  const hasMeetings = component?.meetings?.some(
    (meeting) => meeting && !meeting?.canceledAt,
  );

  let dotColor = SUBTEXT_COLOR;

  if (DOT_COLORS[componentStatus]) {
    const isEndComponent =
      componentStatus === ComponentStatus.Completed ||
      componentStatus === ComponentStatus.Missed ||
      componentStatus === ComponentStatus.NoResponse;
    componentStatus === ComponentStatus.DidNotFinish ||
      componentStatus === ComponentStatus.DidNotPass;

    if (isParticipantView) {
      dotColor =
        !hasMeetings && !isEndComponent
          ? SUBTEXT_COLOR
          : DOT_COLORS[componentStatus] || SUBTEXT_COLOR;
    } else {
      dotColor = DOT_COLORS[componentStatus] || SUBTEXT_COLOR;
    }
  }

  return (
    <div className="xs:p-3.5 xs:rounded-md xs:items-start xs:flex-col flex flex-1 justify-between gap-4 border-1 border-neutral-300 md:flex-row md:items-center md:rounded-lg">
      <div className="flex min-w-fit flex-1 items-center gap-2 text-base font-semibold text-gray-800">
        <Icon icon="dot" size={20} color={dotColor} />
        {component?.name}
      </div>
      <div className="flex xs:gap-2 md:gap-0 xs:items-start xs:flex-col md:flex-row md:items-center text-sm font-normal text-gray-700 md:*:not-first:before:content-['・'] md:*:not-first:before:mx-1.5">
        {component.optional && <div>Optional</div>}
        <div className="flex items-center">
          <OneOneMeetingDateTimeDisplay meeting={component} />
        </div>
      </div>
    </div>
  );
}
